import "waypoints/lib/jquery.waypoints.min.js";

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $btnTrigger = $(".navbar-toggle");

  $(".section-service").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $btnTrigger.addClass("active");
      } else {
        $btnTrigger.removeClass("active");
      }
    },
    offset: "5%",
  });

  $("#news").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $btnTrigger.removeClass("active");
      } else {
        $btnTrigger.addClass("active");
      }
    },
    offset: "10%",
  });

  $(".section-contact").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $btnTrigger.addClass("active");
      } else {
        $btnTrigger.removeClass("active");
      }
    },
    offset: "10%",
  });

  $("#service").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#title-service .text-fluffy").addClass("active-text");
        $("#title-service .reveal-text").addClass("reveal-text-active-white");
      }
    },
    offset: "80%",
  });

  $("#news").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#title-news .text-fluffy").addClass("active-text");
        $("#title-news .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: "80%",
  });

  $("#works").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#title-works .text-fluffy").addClass("active-text");
        $("#title-works .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: 0,
  });

  $("#well-creative").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        setTimeout(function () {
          $("#creative .reveal-text").addClass("reveal-text-active-black");
        }, 2500);
      }
    },
    offset: "80%",
  });

  $("#well-printing").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#printing .text-fluffy").addClass("active-text");
        $("#printing .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: "80%",
  });

  $("#well-camper").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#camper-service .text-fluffy").addClass("active-text");
        $("#camper-service .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: "80%",
  });

  $("#recruit").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#title-recruit .text-fluffy").addClass("active-text");
        $("#title-recruit .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: "80%",
  });

  $("#contact").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        $("#title-contact .text-fluffy").addClass("active-text");
        $("#title-contact .reveal-text").addClass("reveal-text-active-black");
      }
    },
    offset: "80%",
  });
});
